// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Scrollable from "../../../../../library/components/Scrollable.bs.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as TableComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/table/TableComponent.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function CustomerTransactionTableCmp(Props) {
  var data = Props.data;
  var updateTable = Props.updateTable;
  var loader = Props.loader;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var tableColumnsSchema = function (param) {
    return {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Order ID"
              },
              accessor: (function (trans) {
                  return {
                          TAG: /* ActionButton */3,
                          _0: Belt_Option.getWithDefault(trans.order_id, "-"),
                          _1: (function (param) {
                              return Curry._2(workspaceDispatch.addTab, {
                                          TAG: /* OrderDetails */10,
                                          _0: Belt_Option.getWithDefault(trans.order_id, "-"),
                                          _1: undefined
                                        }, false);
                            })
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "Date"
                },
                accessor: (function (trans) {
                    return {
                            TAG: /* Text */0,
                            _0: Timestamp$Catalyst.toString(trans.date, "DD/MM/yyyy")
                          };
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Description"
                  },
                  accessor: (function (trans) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  return React.createElement("p", {
                                              className: "description"
                                            }, Belt_Option.getWithDefault(trans.description, "-"));
                                })
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Reverted"
                    },
                    accessor: (function (trans) {
                        return {
                                TAG: /* Text */0,
                                _0: trans.is_reverted ? "True" : "False"
                              };
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Amount"
                      },
                      accessor: (function (trans) {
                          return {
                                  TAG: /* Custom */5,
                                  _0: (function (param) {
                                      var amount = Currency.toCurrencyString(trans.amount, "");
                                      return React.createElement("span", {
                                                  className: /\-/.test(amount) ? "red" : "green"
                                                }, amount);
                                    })
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Payment Mode"
                        },
                        accessor: (function (trans) {
                            return {
                                    TAG: /* Text */0,
                                    _0: Belt_Option.getWithDefault(trans.payment_mode, "-")
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Balance"
                          },
                          accessor: (function (trans) {
                              return {
                                      TAG: /* Custom */5,
                                      _0: (function (param) {
                                          var amount = Currency.toCurrencyString(trans.wallet_balance, "");
                                          return React.createElement("span", {
                                                      className: /\-/.test(amount) ? "red" : "green"
                                                    }, amount);
                                        })
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "InstaMojo Porter ID"
                            },
                            accessor: (function (trans) {
                                return {
                                        TAG: /* Text */0,
                                        _0: Belt_Option.getWithDefault(trans.instamojo_payment_id, "-")
                                      };
                              })
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          };
  };
  if (loader) {
    return React.createElement(Scrollable.make, {
                height: "100%",
                onScrollEndCallback: (function (param) {
                    return Curry._1(updateTable, String(data.last_date_timestamp));
                  }),
                children: null
              }, React.createElement(TableComponent$Catalyst.make, {
                    columns: tableColumnsSchema(undefined),
                    rowData: data.transactions,
                    className: "c-nlo-table"
                  }), React.createElement(LoadingViewComponent$Catalyst.make, {}));
  } else {
    return React.createElement(Scrollable.make, {
                height: "100%",
                onScrollEndCallback: (function (param) {
                    return Curry._1(updateTable, String(data.last_date_timestamp));
                  }),
                children: null
              }, React.createElement(TableComponent$Catalyst.make, {
                    columns: tableColumnsSchema(undefined),
                    rowData: data.transactions,
                    className: "c-nlo-table"
                  }), List.length(data.transactions) < 1 ? React.createElement("div", {
                      className: "no-data"
                    }, "No Data Available") : null);
  }
}

var make = CustomerTransactionTableCmp;

export {
  make ,
  
}
/* react Not a pure module */
